import FutureImage from '../../FutureImage';
import { Stamp } from '../../Landing/ui';

// Print the post's real GPS position as a typographic artifact — the kind
// of micro-detail that makes the page feel like a field journal. Returns
// null when the post has no coordinates.
function coordinateLine(location) {
  if (
    !location ||
    !location.coordinates ||
    !Array.isArray(location.coordinates.coordinates)
  )
    return null;
  const [longitude, latitude] = location.coordinates.coordinates;
  if (typeof latitude !== 'number' || typeof longitude !== 'number')
    return null;
  const lat = `${Math.abs(latitude).toFixed(4)}° ${latitude >= 0 ? 'N' : 'S'}`;
  const lng = `${Math.abs(longitude).toFixed(4)}° ${
    longitude >= 0 ? 'E' : 'W'
  }`;
  return `${lat} · ${lng}`;
}

// Cover image, framed like a page from a field journal: stable aspect ratio
// (no layout shift, no scroll listeners), a passport stamp on the corner and
// the shot's coordinates typed underneath. This is the LCP element —
// priority-loaded with responsive sizes through the image proxy.
export default function ArticleHero({ coverImage, title, location }) {
  const coords = coordinateLine(location);

  return (
    <figure className="tw-mx-auto tw-mb-10 tw-mt-0 tw-max-w-5xl sm:tw-px-4">
      <div className="tw-relative">
        <div className="tw-relative tw-aspect-[4/3] tw-overflow-hidden tw-shadow-[0_30px_60px_-25px_rgba(29,45,40,0.4)] sm:tw-aspect-[16/9] sm:tw-rounded-[20px] lg:tw-aspect-[21/10]">
          <FutureImage
            src={coverImage.url}
            alt={title}
            fill
            priority
            fetchPriority="high"
            sizes="(max-width: 1024px) 100vw, 1024px"
            className="tw-object-cover"
            placeholder={coverImage.blur ? 'blur' : undefined}
            blurDataURL={coverImage.blur}
          />
        </div>
        <Stamp
          className="tw-absolute -tw-top-6 tw-right-2 tw-hidden tw-h-[4.5rem] tw-w-[4.5rem] tw-rotate-12 tw-text-amber-600/90 dark:tw-text-amber-500/90 sm:tw-block"
          text="TRAVELFEED · FIELD NOTES · "
        />
      </div>
      {coords && (
        <figcaption className="tw-mt-3 tw-px-4 tw-text-center tw-font-mono tw-text-[10px] tw-font-medium tw-tracking-[0.22em] tw-text-[#8A958F] sm:tw-px-1 [&::after]:tw-hidden">
          <span aria-hidden="true">⌖ </span>
          {coords}
        </figcaption>
      )}
    </figure>
  );
}
